<mat-form-field>
  <mat-select placeholder="Select..." (valueChange)="change()" [(ngModel)]="question.answer!.value" name="item">
    <mat-option *ngFor="let item of countries" [value]="item.code">
      {{ item.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
